import { getPhysicianByPatientId } from "@/utils/apis/medicaluser-service"
import { useAuthStore } from "@/utils/stores/useAuthStore"
import { useExpertsStore } from "@/utils/stores/useExpertsStore"
import { useCallback, useEffect, useState } from "react"
import { CalendlyExpert } from "../types/CalendlyExpert"

export const usePhysician = () => {
    const { auth } = useAuthStore()
    const idToken = auth.idToken
    const userId = auth.userId

    const { experts, updateExperts } = useExpertsStore()
    const physician = experts.physician

    const [expert, setExpert] = useState<CalendlyExpert | null>(physician)
    const [sessionExpired, setSessionExpired] = useState(false);

    const fetchPhysician = useCallback(async () => {
        if (!idToken || !userId) return

        try {
            const physician = await getPhysicianByPatientId(idToken, userId);
            if (physician) {
                console.log(`[PHYSICIAN]: physician found -> ${physician.data.name} ${physician.data.family_name}`)
                setExpert(physician);
                updateExperts({ physician });
            } else {
                setExpert(null);
                updateExperts({ physician: null });
            }
        } catch (err) {
            console.log(err)
            if (err instanceof Error && err.message.includes("Session expired")) {
                console.warn("[PHYSICIAN]: session expired");
                setSessionExpired(true);
            } else {
                console.error("Error fetching physician:", err);
            }
        }
    }, [idToken, userId, updateExperts])

    useEffect(() => {
        if (!physician) {
            fetchPhysician()
        } else {
            console.warn("[PHYSICIAN]: already stored, returning it")
            setExpert(physician)
        }
    }, [physician, fetchPhysician])

    return { physician: expert, fetchPhysician, sessionExpired };
}